import * as a from '../../actions/action_types'
export default (state = {}, action) => {
    switch (action.type) {
        case a.UPDATE_DATA:
            return action.payload
        default:
            return state;
    }
};
